import Arrow from "./Icons/Arrow";

const PaginationControls = ({ page, total, pageSize, onPageChange }) => {
  const isFirst = page === 1;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const isLast = page === totalPages;

  const go = (p) => {
    const next = Math.max(1, Math.min(totalPages, p));
    if (next !== page) onPageChange(next);
  };

  return (
    <div className="p-4 border-t">
      <div className="grid grid-cols-1 sm:grid-cols-3 items-center gap-3">
        <div className="order-2 sm:order-1 text-sm text-gray-600 text-center sm:text-left">
          <span className="font-bold">{(page - 1) * pageSize + 1} - {Math.min(page * pageSize, total)}</span> de <span className="font-bold">{total}</span>
        </div>

        <div className="order-1 sm:order-2 flex items-center justify-center gap-1">
          <button
            onClick={() => go(1)} disabled={isFirst}
            className={`py-1 border text-sm ${isFirst ? 'text-gray-300 border-gray-200 cursor-not-allowed' : 'text-gray-600 border-gray-300 hover:bg-gray-50'}`}
            aria-label="Primera página" title="Primera"
          >
            <div className="flex -space-x-4">
              <Arrow turn={'left'}/>
              <Arrow turn={'left'}/>
            </div>            
          </button>
          <button
            onClick={() => go(page - 1)} disabled={isFirst}
            className={`py-1 border text-sm ${isFirst ? 'text-gray-300 border-gray-200 cursor-not-allowed' : 'text-gray-600 border-gray-300 hover:bg-gray-50'}`}
            aria-label="Anterior" title="Anterior"><Arrow turn={'left'}/>
          </button>
          <button
            onClick={() => go(page + 1)} disabled={isLast}
            className={`py-1 border text-sm ${isLast ? 'text-gray-300 border-gray-200 cursor-not-allowed' : 'text-gray-600 border-gray-300 hover:bg-gray-50'}`}
            aria-label="Siguiente" title="Siguiente"><Arrow turn={'right'}/>
          </button>
          <button
            onClick={() => go(totalPages)} disabled={isLast}
            className={`py-1 border text-sm ${isLast ? 'text-gray-300 border-gray-200 cursor-not-allowed' : 'text-gray-600 border-gray-300 hover:bg-gray-50'}`}
            aria-label="Última página" title="Última"
          >
            <div className="flex -space-x-4">
              <Arrow turn={'right'}/>
              <Arrow turn={'right'}/> 
            </div>                         
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaginationControls;
